import React, { Component } from 'react';
import * as regex from '../../../constants/regex';
import InputList from '../../../shared/components/presentation/input-list/InputList';
import { Grid, GridItem } from '../../../shared/components/presentation/grid/Grid';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as webAppointmentActions from '../../actions/webAppointmentActions';
import { nextPage } from '../../functions/nextPage';
import { dropDownDefault } from '../../constants/webAppointmentConstants'
import * as defaultState from '../../constants/DefaultState';
import dobFormatting from '../../../shared/functions/dobFormatting';

export class NewPatientInfoPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rerender: 1
    };
  }
  emptyChoice = dropDownDefault;
  fourdigits = /^[0-9]{4}$/;

  isValid() {
    let valid = (
      this.props.patient.firstName &&
      this.props.patient.lastName &&
      this.props.patient.gender &&
      this.props.patient.maritalStatus &&
      this.props.patient.dob &&
      this.props.patient.dob.match(regex.DATE_OF_BIRTH_REGEX) 
    );
    return !!valid;
  }

  render() {
    const title = "Please help us get to know " +
      (this.props.forMe ? "you" : "the patient") +
      " better.";

    let inputlist = [
      {
        fieldsetLegend: '',
        fieldsetColumns: 2,
        inputs: [
          [
            {
              type: 'text',
              id: 'firstName',
              label: this.props.forMe ? "First name" : "Patient’s first name",
              required: true,
              requiredError: "Please enter " + (this.props.forMe ? "your" : "the patient’s") + " first name.",
              validateOnBlur: true,
              validationErrorClass: "web-appointment__error",
              onChange: (ev) => { this.props.webAppointmentSetPatientFirstName(ev.target.value); },
              existingContent: this.props.patient.firstName || undefined,
              maxLength: '140'
            }
          ],
          [
            {
              type: 'text',
              id: 'lastName',
              label: this.props.forMe ? "Last name" : "Patient’s last name",
              required: true,
              requiredError: "Please enter " + (this.props.forMe ? "your" : "the patient’s") + " last name.",
              validateOnBlur: true,
              validationErrorClass: "web-appointment__error",
              onChange: (ev) => { this.props.webAppointmentSetPatientLastName(ev.target.value); },
              existingContent: this.props.patient.lastName || undefined,
              maxLength: '140'
            }
          ]
        ]
      },
      {
        fieldsetLegend: '',
        fieldsetColumns: 2,
        inputs: [
          {
            type: 'select',
            id: 'gender',
            key: 'gender',
            label: this.props.forMe ? "Gender" : "Patient’s gender",
            required: true,
            requiredError: "Please enter " + (this.props.forMe ? "your" : "the patient’s") + " gender.",
            validateOnBlur: true,
            validationErrorClass: "web-appointment__error",
            onChange: (value) => { this.props.webAppointmentSetPatientGender(value === this.emptyChoice ? "" : value); },
            existingContent: this.props.patient.gender || undefined,
            options: [
              { name: this.emptyChoice, value: undefined },
              { name: 'Female', value: 'Female' },
              { name: 'Male', value: 'Male' },
              { name: 'Transgender', value: 'Transgender' },
              { name: 'Nonbinary', value: 'Nonbinary' },
              { name: 'Other', value: 'Other' },
              { name: 'X', value: 'X' }
            ]
          }
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 2,
        inputs: [
          {
            type: 'select',
            id: 'maritalStatus',
            key: 'maritalStatus',
            label: this.props.forMe ? "Marital status" : "Patient’s marital status",
            required: true,
            requiredError: "Please enter " + (this.props.forMe ? "your" : "the patient’s") + " marital status.",
            validateOnBlur: true,
            validationErrorClass: "web-appointment__error",
            onChange: (value) => { this.props.webAppointmentSetPatientMaritalStatus(value === this.emptyChoice ? "" : value); },
            existingContent: this.props.patient.maritalStatus || undefined,
            options: [
              { name: this.emptyChoice, value: undefined },
              { name: 'Married', value: 'Married' },
              { name: 'Single', value: 'Single' },
              { name: 'Divorced', value: 'Divorced' },
              { name: 'Widowed', value: 'Widowed' },
              { name: 'Domestic Partnership', value: 'Domestic Partnership' },
              { name: 'Legally Separated', value: 'Legally Separated' },
              { name: 'Other', value: 'Other' }
            ]
          }
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 2,
        inputs: [
          {
            id: 'dob',
            key: "dob-" + this.state.rerender,
            type: 'text',
            label: this.props.forMe ? "Date of birth" : "Patient’s date of birth",
            helperText: "Date format: mm/dd/yyyy",
            placeholderText: 'mm/dd/yyyy',
            required: true,
            requiredError: "Please enter " + (this.props.forMe ? "your" : "their") + " date of birth.",
            patternMatch: regex.DATE_OF_BIRTH_REGEX,
            patternMatchError: "Please enter a valid date",
            validateOnBlur: true,
            validateOnChange: true,
            validationErrorClass: "web-appointment__error",
            onChange: (ev) => { this.props.webAppointmentSetPatientDob(ev.target.value); },
            onKeyUp: (ev) => {
              dobFormatting(ev, this, this.props.webAppointmentSetPatientDob);
            },
            existingContent: this.props.patient.dob || undefined
          }
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "button-order margin-top-medium",
        inputs: [
          [
            {
              type: 'button',
              id: "back",
              className: "btn--secondary",
              value: 'Back',
              onClick: () => {
                this.props.history.goBack();
              }
            },
            {
              type: 'button',
              id: "next",
              className: "btn--primary",
              value: 'Next',
              disabled: !this.isValid(),
              onClick: () => {
                this.props.history.push(nextPage());
              }
            }
          ]
        ]
      }
    ];

    return (
      <React.Fragment>
        <Grid columns={1}>
          <GridItem>
            <div className='web-appt__header'>
              <h1>{title}</h1>
              <hr />
            </div>
          </GridItem>
        </Grid>
        <InputList inputs={inputlist} isInlineList={false} />
      </React.Fragment>
    );
  }
}

NewPatientInfoPage.propTypes = {
  patient: defaultState.patientPropType,
  forMe: PropTypes.bool.isRequired,
  webAppointmentSetPatientFirstName: PropTypes.func.isRequired,
  webAppointmentSetPatientLastName: PropTypes.func.isRequired,
  webAppointmentSetPatientGender: PropTypes.func.isRequired,
  webAppointmentSetPatientMaritalStatus: PropTypes.func.isRequired,
  webAppointmentSetPatientDob: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    patient: state.webAppointmentForm.patient,
    forMe: state.webAppointmentForm.forMe
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    webAppointmentSetPatientFirstName: (value) => dispatch(webAppointmentActions.webAppointmentSetPatientFirstName(value)),
    webAppointmentSetPatientLastName: (value) => dispatch(webAppointmentActions.webAppointmentSetPatientLastName(value)),
    webAppointmentSetPatientGender: (value) => dispatch(webAppointmentActions.webAppointmentSetPatientGender(value)),
    webAppointmentSetPatientMaritalStatus: (value) => dispatch(webAppointmentActions.webAppointmentSetPatientMaritalStatus(value)),
    webAppointmentSetPatientDob: (value) => dispatch(webAppointmentActions.webAppointmentSetPatientDob(value))
  };
};

// connects component to redux, and passes along the router
export default connect(mapStateToProps, mapDispatchToProps)(NewPatientInfoPage);
